import axios from "axios";
import moment from "moment";
import React, { useContext, useEffect, useState } from "react";
import ReactPlayer from "react-player";
import { Link, useHistory } from "react-router-dom";
import { serverInfo } from "../../../../../../App";
import { LocationContext } from "../../../../../../CustomHelper/Helper";
import MyVerticallyCenteredModal from "../../../../../RegisterLearningDetails/RegisterNowPay/MyVerticallyCenteredModal";
import Image from "../../../../../../Assets/Images/banner.jpg";
import PayAgain from "../../../../../RegisterLearningDetails/RegisterNowPay/PayAgain";
import Countdown from "react-countdown";
import ContdownTimerRender from "../../../../../../CustomHelper/ContdownTimerRender";
import SharePost from "../../../../../../Screen/SharePost";

const SingleActivity = ({ event, event_type, eventData = null }) => {
  const { imageCdnUrl, videoCdnUrl, domin } = useContext(serverInfo);


  const {
    paymentCount,
    paymentCountWithSymbol,
    payStatus,
    slectedCurrency,
    countryDateTime
  } = useContext(LocationContext);

  const [liveSessionRoom, setLiveSessionRoom] = useState("");
  const [singleEvent, setSingleEvent] = useState("");
  const [pendingPayment, setPendingPayment] = useState();
  const [buffer, setBuffer] = useState(false);
  const [payAgin, setPayAgin] = useState(false);
  const [shareModalShow, setShareModalShow] = useState(false);

  useEffect(() => {
    if (event_type === "livechat") {
      axios.get(`api/user/live-chat/reg_info/${singleEvent.id}`).then((res) => {
        setBuffer(true);
        if (res.data.status === 200) {
          setLiveSessionRoom(res.data.events);
        }
      });
    }
    if (event_type === "meetup") {
      // setPendingPayment(true)
      axios.get(`api/user/registerMeestup-single/${event.id}`).then((res) => {
        setBuffer(true);
        if (res.data.status === 200) {
          res.data.event.payment_status == null
            ? setPendingPayment(true)
            : setPendingPayment(false);
        }
      });
    }

    if (event_type === "learning_session") {
      axios.get(`api/user/learning-single/${event.id}`).then((res) => {
        setBuffer(true);
        if (res.data.status === 200) {
          res.data.event.publish_status == null
            ? setPendingPayment(true)
            : setPendingPayment(false);
        }
      });
    }

    setSingleEvent(event);
  }, [event_type, event]);

  const event_start_time =
    moment(singleEvent.event_date).format("LL") + " " + singleEvent.start_time;
  const event_end_time =
    moment(singleEvent.event_date).format("LL") + " " + singleEvent.end_time;

  const event_start = new Date(countryDateTime(event_start_time, '')).getTime();
  const event_end = new Date(countryDateTime(event_end_time, '')).getTime();
  const history = useHistory();
  const [meetingJoin, setMeetingJoin] = useState(false);

  const CallJoin = (roomId) => {
    setMeetingJoin(true);
    axios.get("/sanctum/csrf-cookie").then((response) => {
      axios.get(`api/sdk/get-token/user`).then((res) => {
        setMeetingJoin(false);
        const authName = localStorage.getItem("auth_name");

        history.push(
          `/video-meeting?token=${res.data.token}&meetingId=${roomId}&webcamEnabled=true&micEnabled=true&name=${authName}&whiteboardEnabled=true&canDrawOnWhiteboard=false&canToggleWhiteboard=false&screenShareEnabled=false&askJoin=true`
        );
        // window.location.href = ;
      });
    });
  };
  console.log('singleEvent', domin + "/greetings-video/" + event?.video);

  const JoinCall = (type, room_id = null) => {

    if (payStatus) {
      if (type === "learning_session") {
        CallJoin(event.room_id);
      } else if (type === "meetup") {
        // alert(event.event_link)
        CallJoin(event.event_link);
      }
    } else {
      alert('please select your current country')
    }

  };
event_type === "greeting" && console.log('greeting',JSON.stringify(event));
  return event_type === "greeting" ? (
    event.status > 3 ? (
      <>
        <div className="col-md-6 col-lg-4 mb-3">
          <div
            className="card CardEn card-bg1 "
            style={{ width: "100%", height: "200px" }}
          >
            <ReactPlayer
              url={videoCdnUrl + event?.video}
              controls={true}
              playing={true}
              volume={1}
              className="Live-Video-x"
              style={{ margin: "0 auto" }}
            />
          </div>
            {event.share_payment_status === 1 ? (
              <div className="sharePostMainDiv" style={{
                position: "unset !important"
              }}>
                <SharePost
                  link={domin + "/greetings-video/" + event?.video.split('/').pop().split('.')[0]}
                  type="greetingShare"
                />
              </div>
            ) : (
              <div className="text-center mt-2">
                <button
                  className="btn btn-warning fw-bold"
                  onClick={() => setShareModalShow(true)}
                >
                  <i className="fas fa-lock me-1"></i> Unlock Share
                </button>
              </div>
            )}

            <MyVerticallyCenteredModal
              show={shareModalShow}
              onHide={() => setShareModalShow(false)}
              event_id={event.id}
              event_type="greetingShare"
              redirectTo="activities"
              fee={paymentCount(event.greeting?.share_cost)}
              baseFee={event.greeting?.share_cost}
            />
        </div>
      </>
    ) : event.payment_status == 1 ? (
      <>
        {" "}
        <div className="col-md-6 col-lg-4 mb-3">
          <div
            className="card CardEn card-bg1 text-warning"
            style={{ width: "100%", height: "200px" }}
          >
            <h4 className="mt-5">Your Greeting Will be Available</h4>
            <img
              src={imageCdnUrl + event?.greeting?.banner}
              alt="Img1"
              className="ImgAc img-fluid"
            />
          </div>
        </div>
      </>
    ) : null
  ) : (
    <>
      {buffer ? (
        <>
          {event_start >= new Date().getTime() ? (
            <div className="col-md-6 col-lg-4 mb-3">
              <div className="card text-center CardEn ">
                {singleEvent.banner ? (
                  <img
                    src={imageCdnUrl + singleEvent.banner}
                    alt="Img1"
                    className="ImgAc img-fluid"
                  />
                ) : (
                  <>
                    <ReactPlayer
                      url={videoCdnUrl + singleEvent.video}
                      controls={true}
                      volume={1}
                      width="100%"
                      // height="200px"
                      className="ImgAc img-fluid"
                    />
                  </>
                )}

                <div className="joinNowBgLive title_text_ellipsis">
                  {singleEvent.title}
                </div>

                {pendingPayment ? (
                  <h6
                    className="fw-bold pt-3 pb-1 text-warning EnHeadLive"
                    onClick={() => setPayAgin(true)}
                  >
                    <div class="spinner-grow text-warning" role="status">
                      <span class="sr-only">Loading...</span>
                    </div>{" "}
                    Payment pending
                  </h6>
                ) : (
                  <h6 className="fw-bold pt-3 pb-1 text-warning EnHeadLive">
                    Waiting
                  </h6>
                )}

                <Countdown
                  date={event_start}
                  renderer={ContdownTimerRender} />
              </div>
            </div>
          ) : event_start < new Date().getTime() &&
            event_end > new Date().getTime() ? (
            <div className="col-md-6 col-lg-4 mb-3">
              <div className="card text-center CardEnLive ">
                {singleEvent.banner ? (
                  <img
                    src={imageCdnUrl + singleEvent.banner}
                    alt="Img1"
                    className="ImgAc img-fluid"
                  />
                ) : (
                  <>
                    <ReactPlayer
                      url={videoCdnUrl + singleEvent.video}
                      controls={true}
                      volume={1}
                      width="100%"
                      // height="200px"
                      className="ImgAc img-fluid"
                    />
                  </>
                )}

                <div className="joinNowBg">Running...</div>

                <div className="joinNowBgLive title_text_ellipsis">
                  {singleEvent.title}
                </div>

                {event_type === "livechat" ? (
                  <button>
                    <h6 className="fw-bold pt-3 pb-1 text-warning EnHeadLiveActive">
                      JOIN NOW
                    </h6>
                  </button>
                ) : event_type === "qna" ? (
                  <Link
                    className="Link"
                    to={{
                      pathname: `/live-chat/video-call`,
                      search: `id=${singleEvent.room_id}`,
                    }}
                  >
                    <h6 className="fw-bold pt-3 pb-1 text-warning EnHeadLiveActive">
                      JOIN NOW
                    </h6>
                  </Link>
                ) : event_type === "learning_session" ? (
                  <>
                    {!pendingPayment && (
                      <a onClick={() => JoinCall("learning_session")}>
                        <h6 className="fw-bold pt-3 pb-1 text-warning EnHeadLiveActive">
                          JOIN NOW{" "}
                          {meetingJoin && (
                            <i className="fas fa-spinner fa-pulse"></i>
                          )}
                        </h6>
                      </a>
                    )}
                  </>
                ) : event_type === "meetup" ? (
                  <>
                    {!pendingPayment && (
                      <a className="Link" onClick={() => JoinCall("meetup")}>
                        <h6 className="fw-bold pt-3 pb-1 text-warning EnHeadLiveActive">
                          JOIN NOW{" "}
                          {meetingJoin && (
                            <i className="fas fa-spinner fa-pulse"></i>
                          )}
                        </h6>
                      </a>
                    )}
                  </>
                ) : (
                  ""
                )}
              </div>
            </div>
          ) : (
            <div className="col-md-6 col-lg-4 mb-3">
              <div className="card text-center CardEn">
                {singleEvent.banner ? (
                  <img
                    src={imageCdnUrl + singleEvent.banner}
                    alt="Img1"
                    className="ImgAc img-fluid"
                  />
                ) : (
                  <>
                    <ReactPlayer
                      url={videoCdnUrl + singleEvent.video}
                      controls={true}
                      volume={1}
                      width="100%"
                      // height="200px"
                      className="ImgAc img-fluid"
                    />
                  </>
                )}

                <div className="joinNowBgLive title_text_ellipsis">
                  {singleEvent.title}
                </div>

                {event_type === "learning_session" &&
                  Number(event.assignment) === 1 &&
                  Number(singleEvent.status) === 5 ? (
                  <Link to={`/learning-activities/${singleEvent.id}`}>
                    <h6 className="fw-bold pt-3 pb-1 text-light EnHeadLive">
                      Assignment
                    </h6>
                  </Link>
                ) : event_type === "learning_session" &&
                  Number(event.assignment) === 1 &&
                  Number(singleEvent.status) === 9 ? (
                  <Link to={`/learning-activities/${singleEvent.id}`}>
                    <h6 className="fw-bold pt-3 pb-1 text-light EnHeadLive">
                      Show Result
                    </h6>
                  </Link>
                ) : event_type === "learning_session" &&
                  Number(event.assignment) === 1 &&
                  Number(singleEvent.status) < 5 ? (
                  <h6 className="fw-bold pt-3 pb-1 text-warning EnHeadLive">
                    Assignment Pending
                  </h6>
                ) : (
                  <h6 className="fw-bold pt-3 pb-1 text-danger EnHeadLive">
                    Expired
                  </h6>
                )}
              </div>
            </div>
          )}

          <MyVerticallyCenteredModal
            show={payAgin}
            onHide={() => setPayAgin(false)}
            event_id={event.id}
            event_type={
              event_type === "learning_session" ? "learningSession" : event_type
            }
            redirectTo="activities"
            fee={paymentCount(event.fee)}
            baseFee={event.fee}
          />
        </>
      ) : (
        <div
          class="spinner-border text-warning"
          role="status"
          style={{ marginLeft: "50px" }}
        >
          <span class="sr-only">Loading...</span>
        </div>
      )}
    </>
  );
};

export default SingleActivity;
